import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
class DeductionItemDisposeDetail extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id || 0,
        showbutton: true,
    }

    componentDidMount = () => {
        const { id } = this.state
        Tyan.doPostEvent({
            event: 'GetDeductionItemDisposeInfo',
            data: { id },
            onEnd: ({ errorMessage, showbutton, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, showbutton, initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    handelSubmit = () => {
        const { id, changedValues基本信息 } = this.state
        // Tyan.pubForm.showConfirm('确定要提交？', () =>
        Tyan.doPostEvent({
            event: 'BatchConfirm',
            data: { ids: [id], changedValues基本信息, action:'发布' },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                if (window.history.length > 1)
                    window.history.back()
                else WeixinJSBridge.call('closeWindow')
            }
        })
        // )
    }

    handlerClose = () => {
        if (window.history.length > 1)
            window.history.back()
        else WeixinJSBridge.call('closeWindow')
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '确认意见')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { showbutton } = this.state
        let fieldsets = []
        if (showbutton) {
            fieldsets.push(
                { _text: '发放月份', disabled: true },
                { _text: '科目名称', disabled: true },
                { _text: '加扣金额（元）', name: '加扣金额' },
                { _text: '备注', maxRows: 3 },
                { _text: '驳回原因', disabled: true, maxRows: 3 },
            )
        }
        else {
            fieldsets.push(
                { _label: '加扣项已确认或驳回', },
            )
        }
        return fieldsets
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, showbutton } = this.state
        if (errorMessage) return <Message text={errorMessage} />
        return <Body data={this} maxWidth="700"
            controls={
                showbutton ? [
                    { _button: '发布', icon: '', handler: this.handelSubmit, disabled: !this.bChanged() },
                    { _button: this.bChanged() ? '取消' : '关闭', icon: '', handler: this.handlerClose },
                ] : [{ _button: '关闭', icon: '', handler: this.handlerClose },]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default connect()(DeductionItemDisposeDetail)